export default __webpack_public_path__ + "media/images/icons/whatsapp-filled-72a9a6c7512bbffdd044ef729e635329.svg";